var Confetti = function(canvas, opts){
    // src: https://codepen.io/Gthibaud/pen/bNOZjd
    // https://codepen.io/jscottsmith/pen/VjPaLO
    this.gauss = gaussian(0.5, 0.2);

    this.context = canvas.getContext('2d');
    this.width = canvas.width = window.innerWidth
    this.height = canvas.height = window.innerHeight

    this.running = true

    this.particle = [];
    this.particleCount = 200;
    this.gravity = 0.28;
    this.drag = 0.982;

    opts = opts || {}

    const colorPalletes = {
        default: ['#5b8da3', '#7db286', '#ffcc64', '#d7775d'],
        blue: ['#5b8da3', '#8cb0bf', '#adc6d1', '#2e4752', '#1b2a31', '#ffcc64'],
        green: ['#7db286', '#8fbd97', '#afd0b4', '#42704a', '#1c3020', '#ffcc64'],
        yellow: ['#ffcc64', '#ffd580', '#e69a00', '#b37800', '#805600'],
        red: ['#d7775d', '#dc8770', '#e6a999', '#8f3a23', '#662a19', '#ffcc64'],
        purple: ['#7e70a2', '#9d93b9', '#b9b2cd', '#51466c', '#231e2e', '#ffcc64'],
    }

    this.colors = colorPalletes[opts.color || 'default']

}

Confetti.prototype.init = function() {
    // create all particles
    for( var i = 0; i < this.particleCount; i++){

        const direction = this.randomRange(-30, 30) // degrees
        const velocity = this.randomRange(-52, -14)
        const context = this.context

        const self = this

        this.particle.push({

            x: this.width/2,
            y: this.height/1.5,

            boxW: this.randomRange(5,20),
            boxH: this.randomRange(5,20),

            velX: Math.sin( convertToRadians(direction) ) * velocity,
            velY: Math.cos( convertToRadians(direction) ) * velocity,

            angle: convertToRadians(this.randomRange(0,360)),
            color: this.colors[Math.floor(Math.random() * this.colors.length)],
            anglespin: this.randomRange(-0.2,0.2),

            draw: function() {

                context.save();
                context.translate(this.x, this.y);
                context.rotate(this.angle);
                context.fillStyle = this.color;
                context.beginPath();
                context.fillRect(this.boxW/2*-1, this.boxH/2*-1, this.boxW, this.boxH);
                context.fill();
                context.closePath();
                context.restore();

            },

            update: function() {

                this.angle += this.anglespin;

                this.velY *= self.drag;
                this.velY += self.gravity;

                this.x += this.velX;
                this.y += this.velY;

                if (this.y < 0) {
                    this.velY *= -0.2;
                    this.velX *= 0.9;
                }

                if (this.y > self.height) {
                    this.anglespin = 0;
                    this.y = self.height;
                    this.velY *= -0.2;
                    this.velX *= 0.9;
                }

                if (this.x > self.width || this.x < 0) {
                    this.velX *= -0.2;
                }

            }


        });

    }
}



/**
 * Render the confetti
 */
Confetti.prototype.render = function() {

    this.context.clearRect(0,0,this.width,this.height);

    for( var i = 0; i < this.particle.length; i++){
        this.particle[i].draw();
        this.particle[i].update();
    }

    if ( this.running ) {
        requestAnimationFrame(this.render.bind(this));
    }

}

Confetti.prototype.stop = function() {
    this.running = false
}

/**
 * Generate a random normal distributed number between min and max
 * @param  {float} min
 * @param  {float} max
 * @return {float} randomly generated number
 */
Confetti.prototype.randomRange = function(min, max) {
    return min + this.gauss() * (max - min );
}

/**
 * Convert degrees to radians
 * @param  {float} degrees
 * @return {float} angle in radians
 */
function convertToRadians(degree) {
    return degree*(Math.PI/180);
}

/**
 * Creates function that returns normal distributed random number
 * @param  {float} mean
 * @param  {float} stdev
 * @return {() => float} function that returns random number when called
 */
function gaussian(mean, stdev) {

    var y2;
    var use_last = false;

    return function() {

        var y1;

        if(use_last) {

            y1 = y2;
            use_last = false;

        } else {

            var x1, x2, w;

            do {
                x1 = 2.0 * Math.random() - 1.0;
                x2 = 2.0 * Math.random() - 1.0;
                w  = x1 * x1 + x2 * x2;
            } while( w >= 1.0);

            w = Math.sqrt((-2.0 * Math.log(w))/w);
            y1 = x1 * w;
            y2 = x2 * w;
            use_last = true;
        }

        return Math.abs( mean + stdev * y1 );

    }
}

let cf;
export function start(el, color) {
    cf = new Confetti(el, { color })
    cf.init()
    cf.render()
}

export function stop() {
    cf.stop()
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/elements/confetti.js